// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2M1bs","Nav":"Header_Nav__wJD_a","theme-light":"Header_theme-light__jB8XX","NavItem":"Header_NavItem__2MQPM","theme-dark":"Header_theme-dark__2-4PB"};